import gql from 'graphql-tag';

const createProviderMutation = gql`
  mutation createProvider($name: String!) {
    createProvider(name: $name){
      ok
      provider {
        id
        name
      }
    }
  }
`;

export default createProviderMutation